/* ######################################################################################################################## */
/* FUNCTION (ACCORDION) ################################################################################################### */
/* ######################################################################################################################## */
function accordion(speed, ease)
{
	jQuery('.js-accordion_trigger').on('click', function(e)
	{
		e.stopPropagation();

		var jQthis      = jQuery(this);
			idAccordion = jQthis.parents('.js-accordion').attr('id');
			idBlock     = jQthis.parents('.js-accordion_block').attr('id');

		if(!jQuery('#' + idBlock).hasClass('open'))
		{
			jQuery('.js-accordion_block.open', '#' + idAccordion)
				.removeClass('open')
				.find('.js-accordion_container').slideUp(speed, ease);

			jQuery('#' + idBlock)
				.addClass('open')
				.find('.js-accordion_container').slideDown(speed, ease, function()
				{
					/*
					jQuery('html, body').animate(
					{
						scrollTop : (jQuery('#' + idBlock).offset().top - jQuery('#main-navigation').height() - 24)
					}, speed * 3, ease);
					*/
				});
		}
		else
		{
			jQuery('#' + idBlock)
				.removeClass('open')
				.find('.js-accordion_container').slideUp(speed, ease);
		}
	});
}
